import { render } from "./MomentView.vue?vue&type=template&id=514f359c&scoped=true"
import script from "./MomentView.vue?vue&type=script&lang=js"
export * from "./MomentView.vue?vue&type=script&lang=js"

import "./MomentView.vue?vue&type=style&index=0&id=514f359c&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-514f359c"]])

export default __exports__